import React, { Component } from "react";
import Msg from "./Msg";

class App extends Component {
  state = {
    msg: {}
  };

  handleSubmit = async e => {
    e.preventDefault();
    this.setState({
      msg: {
        type: "working",
        text: "Working...Please wait."
      }
    });

    let data = new FormData();
    data.append("acct", this.acct.value);
    data.append("name", this.name.value);
    data.append("phone", this.phone.value);
    data.append("email", this.email.value);
    data.append("mobile", this.mobile.value);

    try {
      const response = await fetch(`https://loxahatcheeriver.org/api/emergencyNotify`, {
        method: "POST",
        body: data
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        this.setState({
          msg: {
            type: "success",
            text: json.text
          }
        });
        this.acct.value = "";
        this.name.value = "";
        this.phone.value = "";
        this.email.value = "";
        this.mobile.value = "";
      } else {
        this.setState({
          msg: {
            type: "error",
            text: json.text
          }
        });
      }
    } catch (error) {
      this.setState({
        msg: {
          type: "error",
          text: "An error has occurred."
        }
      });
    }
  };

  render() {
    return (
      <div className="App">
        <article className="step">
          <div className="step-container">
            <h1>Emergency Notifications</h1>
          </div>
          <form onSubmit={this.handleSubmit}>
            <div className="row-two">
              <div>
                <label>LRD Account Number</label>
                <input
                  type="text"
                  ref={ref => (this.acct = ref)}
                  placeholder=""
                  autoComplete="off"
                />
              </div>

              <div>
                <label>Name</label>
                <input
                  type="text"
                  ref={ref => (this.name = ref)}
                  placeholder=""
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="row-two">
              <div>
                <label>Phone Number</label>
                <input
                  type="text"
                  ref={ref => (this.phone = ref)}
                  placeholder=""
                  autoComplete="off"
                />
              </div>

              <div>
                <label>Email Address</label>
                <input
                  type="text"
                  ref={ref => (this.email = ref)}
                  placeholder=""
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="row-two">
              <div>
                <label>Mobile Number (for text messages)</label>
                <input
                  type="text"
                  ref={ref => (this.mobile = ref)}
                  placeholder=""
                  autoComplete="off"
                />
              </div>

              <div />
            </div>

            <Msg msg={this.state.msg} />
            <div className="row-btn">
              <button type="submit">
                Continue&nbsp; <i className="fa fa-angle-right" />
              </button>
            </div>
          </form>
        </article>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js